import { CROSS_TENANT_HISTORY_STATES, CROSS_TENANT_HISTORY_STATES_RECEIVER } from '@/class/cargo/model/parameters/SeaExportConstants'
import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import DateUtils from '@/utils/dateUtils'
import { CrossTenantHistory } from '@/class/model/booking/CrossTenantHistory'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { loadSpecificBasicInfo } from '@/api/cache'
import { getContractNoList } from '@/api/seaExport/contractNo'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getSubscribePortPushTenantList } from '@/api/sysManage/subscribePortPushRule'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { dateCompare, mergeArray } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'

export class TabOrderCarPM {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    this.view = view
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get user() {
    return this.view.context.user
  }
  set user(user) {
    this.view.context.user = user
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    this.view.config = config
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  init() {
  }
  changeJob() {
  }
  /**
   * fill view
   */
  fillView() {
  }
  print() {
  }
}
